import React from 'react';
import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import TotalsCardStyled from './TotalsCardStyled';
import AsmubipButton from './AsmubipButton';

type HomeTotalsCardProps = {
  label: string;
  value: string;
  seeMoreTarget: string;
  isMobile: boolean;
};

export default function HomeTotalsCard({
  label,
  value,
  seeMoreTarget,
  isMobile,
}: HomeTotalsCardProps) {
  const navigate = useNavigate();
  return (
    <TotalsCardStyled mode="dark" isMobile={isMobile}>
      <Typography sx={{ textAlign: 'center', fontSize: '16px' }}>{label}</Typography>
      <Typography sx={{ textAlign: 'center', fontSize: '32px' }}>{value}</Typography>
      <Box sx={{ p: 1 }}>
        <AsmubipButton
          variant="contained-secondary"
          sx={{ width: '100%', marginTop: 2 }}
          onClick={() => {
            navigate(seeMoreTarget);
          }}>
          Ver Mais
        </AsmubipButton>
      </Box>
    </TotalsCardStyled>
  );
}
